'use strict';

const {UriBuilder} = require("uribuilder");

module.exports = /* @ngInject */ function ($scope, $http, iframeConfig, $sce) {
    $scope.$on('$destroy', handleDestroy);

    $scope.iFrameUrl = '';
    $scope.iFrameLoaded = false;
    $scope.iframeId = window.MAIN_IFRAME_ID;

    let iframeEl;

    $scope.init = function () {
        iframeConfig.listenToIframeMessages($scope.iframeId);
        const eprocVersion = sessionStorage.getItem(STORAGE_KEY.EPROC_VERSION);
        $scope.iFrameUrl = UriBuilder.parse(location.protocol + '//' + iframeConfig.iframeBase + window.getIFrameRoute());
        iframeEl = angular.element(`#${$scope.iframeId}`);
        iframeEl[0].onload = () => {
            $scope.iFrameLoaded = true;
            $scope.$apply();
        }
        $scope.iFrameUrl.query.version = eprocVersion;
        iframeEl.attr('src', $scope.trustSrc($scope.iFrameUrl.toString()));
    };

    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    function handleDestroy() {
        iframeConfig.stopListeningToIframeMessages();
    }
};
